import axios from "axios";
// import store from "../_store";

const AUTH_ROUTE_PATTERN = /(authenticate|validate-jwt|refresh-jwt)/;

function getAuthenticationToken() {
  try {
    const authentication = JSON.parse(localStorage.getItem("authentication"));
    return authentication && authentication.token ? authentication.token : null;
  } catch (error) {
    return null;
  }
}

function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}

function isURLSearchParams(value) {
  return typeof URLSearchParams !== "undefined" && value instanceof URLSearchParams;
}

function isPlainObject(value) {
  return Object.prototype.toString.call(value) === "[object Object]";
}

function buildFormPayload(data = {}) {
  const payload = new URLSearchParams();

  Object.keys(data).forEach(key => {
    const value = data[key];

    if (value === undefined || value === null) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach(item => payload.append(key, item));
      return;
    }

    payload.append(key, isPlainObject(value) ? JSON.stringify(value) : value);
  });

  return payload;
}

/**
 * Create a new Axios client instance
 * @see https://github.com/mzabriskie/axios#creating-an-instance
 */
const getClient = (baseUrl = null) => {
  const options = {
    baseURL: baseUrl
  };

  // if (store.state.authentication.user) {
  //   // console.log(store.state.authentication.user);
  //   // options.headers = {
  //   //   Authorization: `Bearer ${store.getters['users/accessToken']}`,
  //   // };
  // }

  const client = axios.create(options);

  // Add a request interceptor
  client.interceptors.request.use(
    requestConfig => {
      const config = requestConfig;
      const token = getAuthenticationToken();
      const method = (config.method || "get").toLowerCase();
      const hasAuthRoute = AUTH_ROUTE_PATTERN.test(config.url || "");

      config.headers = config.headers || {};
      delete config.headers["X-Requested-With"];
      delete config.headers.Authentication;
      delete config.headers.Authorization;

      if (token && !hasAuthRoute) {
        config.params = Object.assign({}, config.params, { jwt: token });
      }

      if (
        ["post", "put", "patch"].includes(method) &&
        isPlainObject(config.data) &&
        !isFormData(config.data) &&
        !isURLSearchParams(config.data)
      ) {
        config.data = buildFormPayload(config.data);
        config.headers["Content-Type"] =
          "application/x-www-form-urlencoded;charset=UTF-8";
      } else if (["get", "delete", "head", "options"].includes(method)) {
        delete config.headers["Content-Type"];
      }

      return config;
    },
    requestError => {
      // Raven.captureException(requestError);

      return Promise.reject(requestError);
    }
  );

  // Add a response interceptor
  client.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status == 401) {
        // Unauthorized
      }
      if (error.response.status == 403) {
        // Forbiden
      }
      if (error.response.status >= 500) {
        // Raven.captureException(error);
      }

      return Promise.reject(error);
    }
  );

  return client;
};

class NewClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }

  get(url, conf = {}) {
    return this.client
      .get(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  delete(url, conf = {}) {
    return this.client
      .delete(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  head(url, conf = {}) {
    return this.client
      .head(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  options(url, conf = {}) {
    return this.client
      .options(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  post(url, data = {}, conf = {}) {
    return this.client
      .post(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  put(url, data = {}, conf = {}) {
    return this.client
      .put(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  patch(url, data = {}, conf = {}) {
    return this.client
      .patch(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
}

export { NewClient };

/**
 * Base HTTP Client
 */
export default {
  // Provide request methods with the default base_url
  get(url, conf = {}) {
    return getClient()
      .get(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  delete(url, conf = {}) {
    return getClient()
      .delete(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  head(url, conf = {}) {
    return getClient()
      .head(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  options(url, conf = {}) {
    return getClient()
      .options(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  post(url, data = {}, conf = {}) {
    return getClient()
      .post(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  put(url, data = {}, conf = {}) {
    return getClient()
      .put(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  },

  patch(url, data = {}, conf = {}) {
    return getClient()
      .patch(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
};
